import type { Requests } from "../common/request.common";
import type { CustomerInvoiceResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const customerInvoice = {
    record(customerId?: string) {
        return (data: typeof Requests.CustomerInvoice.Record.Input) => {
            return post<typeof data, CustomerInvoiceResponseTypes.Record>(
                `/customer-invoice/record/${customerId ?? ""}`,
                data,
            );
        };
    },
    entries(data: typeof Requests.CustomerInvoice.Entries.Input) {
        return post<typeof data, CustomerInvoiceResponseTypes.Entries>(
            `/customer-invoice/entries`,
            data,
        );
    },
    create(data: typeof Requests.CustomerInvoice.Create.Input) {
        return post<typeof data>(`/customer-invoice/create`, data);
    },
    obtain(id: string) {
        return get<CustomerInvoiceResponseTypes.Obtain>(`/customer-invoice/obtain/${id}`);
    },
    formHooks: {
        selectPeriodFn(id: string | undefined) {
            return async () => {
                if (id === undefined) {
                    return [];
                }

                return (
                    (await get<CustomerInvoiceResponseTypes.Select>(
                        `/customer-invoice/select-period/${id}`,
                    ).execute()) ?? []
                );
            };
        },
    },
};
